import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const DropletOutlinedIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M9.99902 1.4946C10.9995 1.49458 11.5762 2.02115 12.3594 2.69479C14.3446 4.40232 17.2665 7.57217 17.2666 11.5434C17.2665 13.9656 16.3685 15.8283 14.9854 17.0805C13.6125 18.3233 11.7973 18.933 10 18.9331C8.20262 18.933 6.38655 18.3234 5.01367 17.0805C3.63071 15.8283 2.7335 13.9655 2.7334 11.5434C2.73348 7.57226 5.65458 4.40235 7.63965 2.69479C8.42275 2.02119 8.99889 1.49489 9.99902 1.4946ZM9.99902 2.69479C9.51656 2.695 9.27423 2.87261 8.42285 3.60495C6.47571 5.27986 3.9327 8.13841 3.93262 11.5434C3.93272 13.6474 4.70274 15.1798 5.81934 16.1909C6.94626 17.2111 8.46439 17.7328 10 17.7329C11.5357 17.7328 13.0537 17.2111 14.1807 16.1909C15.2973 15.1798 16.0663 13.6475 16.0664 11.5434C16.0663 8.13832 13.5234 5.27984 11.5762 3.60495C10.7245 2.87242 10.482 2.69479 9.99902 2.69479Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
